import NiceSelect from 'nice-select2/dist/js/nice-select2';

(function ($) {
  const customSelectThemes = {};

  document
      .querySelectorAll('select[name="theme"]')
      .forEach(selectEl => {
        customSelectThemes[selectEl.innerHTML] = new NiceSelect(selectEl, {placeholder: Drupal.t('Выберите тему')});
      })

  document
      .querySelectorAll('[data-modal="upload-photo-report"], [data-modal="upload-photo-contest-work"]')
      .forEach(modal => {
        modal.addEventListener('open', () => {
          modal
              .querySelectorAll('form')
              .forEach(form => formReset(form));

          if (!!modal.defaultTheme) {
            let selectEl = modal.querySelector('select[name="theme"]');
            if (selectEl) {
              selectEl.value = modal.defaultTheme;
              if (customSelectThemes[selectEl.innerHTML]) {
                customSelectThemes[selectEl.innerHTML].update();
                customSelectThemes[selectEl.innerHTML].disable();
              }
            }
          }
        })
      })

  $('.form_photo-report').submit(function (e) {
    e.preventDefault();
    const modalForm = this.closest('[data-modal]');
    const modalLoading = document.querySelector('[data-modal="loading"]');
    const modalMessage = document.querySelector('[data-modal="message"]');

    if (modalForm) modalForm.classList.remove('modal_show');
    if (modalLoading) modalLoading.classList.add('modal_show');

    const form = this;
    const formData = new FormData(form);
    let message;
    $.ajax({
      type: form.getAttribute('method'),
      url: form.getAttribute('action'),
      data: formData,
      contentType: false,
      processData: false,
    }).done(function () {
      message = Drupal.t('Ваши фото успешно загружены');
      formReset(form);
      let modalEl = form.closest('[data-modal]')

      if (modalEl && !!modalEl.defaultTheme) {
        let btn = document.querySelector('[data-theme="' + modalEl.defaultTheme + '"]');

        if (btn) {
          btn.setAttribute('disabled', 'true');
        }

        document
            .querySelectorAll('a[data-theme="' + modalEl.defaultTheme + '"]')
            .forEach(bEl => {
              bEl.classList.remove('card__button_green');
              bEl.setAttribute('disabled', 'true');
            })
      }
    }).fail(function (e) {
      console.log('fail', e);
      message = Drupal.t('Произошла ошибка, попробуйте еще раз');
    }).always(function () {
      if (modalMessage) {
        const messageElement = modalMessage.querySelector('.modal__message');
        if (messageElement) {
          messageElement.innerHTML = message;
        }
      }

      if (modalLoading) modalLoading.classList.remove('modal_show');
      if (modalMessage) modalMessage.classList.add('modal_show');
    });
  });

  function formReset(form) {
    if (!form) return;
    form.reset();

    const fileList = form.querySelector('.input-file__list');
    if (fileList) {
      while (fileList.firstChild) {
        fileList.removeChild(fileList.firstChild);
      }
    }

    let selectEl = form.querySelector('select[name="theme"]');

    if (selectEl && selectEl.innerHTML in customSelectThemes) {
      customSelectThemes[selectEl.innerHTML].clear();
    }
  }
})(jQuery);